export const initialProcessData = {
  ruts_a: [],
  ruts_b: [],
  file: undefined,
}

export const basicEnrichment = 'basico'
export const interestConflictEnrichment = 'conflicto-de-interes'

export const rutsAKey = 'ruts_a'
export const rutsBKey = 'ruts_b'
export type rutsKeys = typeof rutsAKey | typeof rutsBKey
